import { PlusOutlined } from "@ant-design/icons"
import { Button, Flex, Typography } from "antd"
import dayjs from "dayjs"
import React from "react"

import type { CalendarModalData } from "../../redux/calendar.types.ts"

const { Title, Text } = Typography

interface CalendarHeaderProps {
  createAllowed?: boolean
  onSetModalData: (data: CalendarModalData | null) => void
}

export function CalendarHeader({
  createAllowed,
  onSetModalData
}: CalendarHeaderProps) {
  const onOpenAddModal = () => {
    const today = dayjs.tz()

    onSetModalData({
      date: today,
      start_at: null,
      end_at: null
    })
  }

  return (
    <div className="flex lg:items-center gap-3 max-lg:flex-col justify-between py-1">
      <Flex vertical gap={4}>
        <Title level={3} className={"text-start mb-0 font-bold !text-2xl"}>
          Calendar & Appointments
        </Title>
        <Text type={"secondary"} className={"text-sm"}>
          Manage lead meetings, site visits, and follow-ups
        </Text>
      </Flex>

      {createAllowed && (
        <Button
          type={"primary"}
          size={"large"}
          onClick={onOpenAddModal}
          icon={<PlusOutlined />}
        >
          Event
        </Button>
      )}
    </div>
  )
}
